module.exports = __webpack_public_path__ + "static/media/instagram.03b19e29.svg";